import { Constants } from "../constants/Contants";
import request from "../utils/useApi";

export const getAllDealsApi = async (merchant) => {
  try {
    const res = await request.get(`${Constants.get_all_deals}/${merchant}`);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const updateDealsApi = async (deal, data) => {
  try {
    const res = await request.patch(`${Constants.update_deal_api_url}/${deal}`, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};